import React from "react";
import FontsFormStyle from "../FontsFormStyle";

const FontsStyle = (styleForm) => {
  return (
    <span>
      <FontsFormStyle
        pickerId="2"
        apiKey={process.env.GOOGLE_API_KEY}
        title="Questions"
        styleFormAll={styleForm.styleQuestions}
      />

      <FontsFormStyle
        pickerId="3"
        apiKey={process.env.GOOGLE_API_KEY}
        title="Answer"
        styleFormAll={styleForm.styleAnswer}
      />
    </span>
  );
};

export default FontsStyle;
